import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TicketDetailDto, TicketDto } from "src/store/ticket/type";

import PerfectScrollBar from "react-perfect-scrollbar";
import TicketListCard from "./componentes/ticketListCard";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const TicketSideBar = ({
  tickets,
  closeTickets,
  selectedTicket,
}: {
  selectedTicket?: TicketDetailDto;
  tickets: TicketDto[];
  closeTickets: TicketDto[];
}) => {
  const navigate = useNavigate();
  const { tab, id }: any = useParams();
  const [activeTab, setActive] = useState(tab ? tab : id);
  const { t } = useTranslation();
  const setActiveTab = (tab: any) => {
    setActive(tab);
    return navigate("/ticket/" + tab);
  };
  return (
    <React.Fragment>
      <div className="ticketSideBar">
        <Nav className="multiLanguageNavbar nav-tabs-custom mx-3">
          <NavItem key={"all"}>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: activeTab === "all",
              })}
              onClick={() => setActiveTab("all")}
            >
              {t("Tickets.AllTickets")}
            </NavLink>
          </NavItem>
          <NavItem key={"closed"}>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({
                active: activeTab === "closed",
              })}
              onClick={() => setActiveTab("closed")}
            >
              {t("Tickets.ClosedTickets")}
            </NavLink>
          </NavItem>
        </Nav>

        <div className="ticketListContainer">
          <PerfectScrollBar>
            {activeTab === "all" && (
              <>
                {tickets.map((x) => (
                  <TicketListCard
                    ticket={x}
                    key={x.Id}
                    selected={
                      selectedTicket && selectedTicket.Id === x.Id
                        ? true
                        : false
                    }
                  />
                ))}
              </>
            )}
            {activeTab === "closed" && (
              <>
                {closeTickets.map((x) => (
                  <TicketListCard
                    ticket={x}
                    key={x.Id}
                    selected={
                      selectedTicket && selectedTicket.Id === x.Id
                        ? true
                        : false
                    }
                  />
                ))}
              </>
            )}
          </PerfectScrollBar>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketSideBar;
